import { Injectable } from "@angular/core";

export interface PlanPrices {
  benefitLevel: number;
  coverages: Coverage[];
  frequency: string;
  frequencyText?: string;
  plan: string;
  netPrime?: number;
  prime: number;
  netPrimeYear?: number;
  primeYear?: number;
  product: string;
  productCode: string;
  rangeAge: string;
  sumAssured: number;
  totalPrime: number;
  totalPrimeYear?: number;
}

export interface Coverage {
  coverageIndex: number;
  amount: number;
  title: string;
}

@Injectable({
  providedIn: "root",
})
export class PlanPricesService {
  constructor() {}

  getPlanPricesFromLocalStorage(): PlanPrices {
    return localStorage.getItem("planPrices") === null ||
      localStorage.getItem("planPrices") === ""
      ? {}
      : JSON.parse(localStorage.getItem("planPrices"));
  }

  savePlanPricesInLocalStorage(planPrices: PlanPrices): void {
    planPrices = {
      ...planPrices,
      netPrime: +(+planPrices.totalPrime * 0.84).toFixed(2)
    }
    localStorage.setItem("planPrices", JSON.stringify(planPrices));
  }
}
